<div 
    class="absolute inset-0"
    *transloco="let t;"
>
    <!-- Main -->
    <div
        class="flex h-full flex-auto flex-col items-center justify-center p-6 sm:p-10"
    >
        <!-- prettier-ignore -->
        <div class="w-full max-w-3xl">
            <div class="flex flex-col items-center justify-center">
                <img
                    class="h-65 w-auto"
                    src="images/page-not-found.png"
                    alt="404"
                />
            </div>
        </div>
        <div
            class="mt-12 text-center text-4xl font-extrabold leading-tight tracking-tight sm:mt-24 md:text-7xl md:leading-none"
        >
            {{t('pages.404.ops')}}   
        </div>
        <div
            class="text-secondary mt-2 text-center text-lg font-medium tracking-tight md:text-xl"
        >
            {{t('pages.404.error-404')}}  
        </div>

        <button class="ml-4 mt-4" mat-flat-button [color]="'primary'" (click)="goHome()">
            <mat-icon [svgIcon]="'heroicons_outline:home'"></mat-icon>
            <span class="ml-2 mr-1">{{t('pages.404.go-back')}}</span>
        </button>
             
    </div>
</div>
